<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
              <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-2 col-md-12 col-2">
                    <h2>Hidden Offers</h2>
                    </div>
                   
                </div>
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
              <div class="d-flex justify-content-between">
                  <h5 class="ml-3">Filters</h5>
                  <span class="btn btn-link" @click="showFilters = !showFilters">
                  <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
                  </span>
              </div>
              <div class="row" v-if="showFilters">
                  <div class="col-lg-12">
                      <form class="row">
                      <div class="col-md-6 col-lg-3 mt-2">
                          <label for="filter" class="">Cusip</label>
                          <input v-model="selectedCusip" type="text" class="form-control" id="filterId" placeholder="Cusip">
                      </div>
                      <div class="col-md-6 col-lg-3 mt-2">
                          <label for="filter" class="">Filter</label> 
                           <select class="form-control cursor-pointer" id="exampleFormControlSelect1"
                                v-model="selectedFilter">
                                <option value>Please select</option>
                                <option v-for="filter in matchedFilterList" :key="filter.id" v-bind:value="filter.filterName">
                                    {{ filter.filterName }}</option>
                                </select>
                      </div>
                      <div class="col-md-6 col-lg-3">
                          <button @click="clearFilter()" type="button" class="btn btn-secondary rounded">Clear</button>
                          <button  @click="getHiddenOffers()" type="button" class="btn btn-primary rounded">Filter</button>
                      </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
        <div class="container-fluid">
            <div class="row xsOnly">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                          <div class="row">
                            <div class="col-md-9"></div>
                            <!-- <div class="col-md-3">
                                <toggle-button v-model="isSearchOnly" @change="search" style="padding: 5px;"/> SAVED SEARCHES
                            </div> -->
                        </div> 
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                              <th
                                  scope="col" 
                                  class="sort text-left"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'name'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'name'  ? 'sort-desc' : '']"  
                                  @click="sort('name')">CUSIP</th>
                                <th
                                scope="col" 
                                class="sort text-left"
                                >Filter</th>
                                <th
                                scope="col" 
                                class="sort text-left"
                                >Price Hidden From</th>
                                
                                <th
                                scope="col" 
                                class="sort text-center"
                                >Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="savedFilters.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in savedFilters" :key="data.id">
                              <td class="text-left">{{data.cusip}}</td>
                              <td class="text-left">{{data.filterName}}</td>
                              <td class="text-left">
                                <input type="number" v-model="data.price" class="form-control" style="width:100px;display:inline-block;margin-left:10px"/>
                              </td>
                              
                               <td class="text-center">
                                <button @click="updateFilter(data)" class="btn btn-primary" type="button">
                                    <i class="fas fa-check"></i>UPDATE
                                  </button>
                                  <button @click="deleteFilter(data)" class="btn btn-danger" type="button">
                                    <i class="fas fa-trash"></i>DELETE
                                  </button>
                                  
                               </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getHiddenOffers(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>

    </div>    
    
</template>
<script>
import config from "@/config";
import authService from "@/authService";

export default {
  name: "imsCusipComponent",
  components : {
    
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "id",
        sortOrder: "DESC",
        savedFilters : [],
        status :"ACTIVE,INACTIVE",
        showAddFilterModal : false,
        selectedFilter : null,
        isSearchOnly : false,
        showFilters : false,
        matchedFilterList: [],
        selectedCusip : ""
        

    };
  },
  methods: {
    getIdByFilterName(filterName) {
      const item = this.matchedFilterList.find(item => item.filterName === filterName);
      return item ? item.id : null; // Return the id if found, otherwise return null
    },
    clearFilter(){
      this.selectedCusip = "";
      this.selectedFilter = null;
      this.getHiddenOffers();
    },
    getMatchedFilter() {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
          "/offering-feed/filter-dropdown?userId=" + authService.getUser().id,
          auth
        )
        .then((res) => {
          this.matchedFilterList = res.data.content;
        })
        .catch(e => {
          console.log(e);
        });
    },
    updateFilter(filter){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        let addData = {
          "userId": authService.getUser().id,
          "filterId": filter.filterId,
          "cusip": filter.cusip,
          "price": filter.price
        }
        this.$http
        .put(config.baseUrlAutoBidder + "/offering-feed/hide",addData,auth)
        .then(() => {
            this.loading = false; 
            this.getHiddenOffers();
            this.$alert("Hidden offer updated", "", "success");

        })
        .catch(() => {
            this.loading = false;              
        }); 
    },
    deleteFilter(filter){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        let addData = {
          "userId": authService.getUser().id,
          "filterIds": [filter.filterId],
          "cusip": filter.cusip
        }
        this.$http
        .post(config.baseUrlAutoBidder + "/offering-feed/unhide",addData,auth)
        .then(() => {
            this.loading = false; 
            this.getHiddenOffers();
            this.$alert("​Offer removed from hide list", "", "success");

        })
        .catch(() => {
            this.loading = false;              
        }); 
    },
    getHiddenOffers(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/offering-feed/hide/list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.selectedCusip +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&userId="+
            authService.getUser().id+
            "&filterId="+
            (this.selectedFilter ? this.getIdByFilterName(this.selectedFilter) : ""),
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(element => {
            if(element.status == "ACTIVE"){
              element.enable = true
            }else{
              element.enable = false

            }
          });
          this.savedFilters = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    }
   
  },
  mounted() {
    this.getHiddenOffers();
    this.getMatchedFilter();
  }
};
</script>
<style scoped>
  .psticky {
    position: sticky;
    top: -21px;
    z-index: 9999;
  }
</style>